import { render, staticRenderFns } from "./UnusedResources.vue?vue&type=template&id=44b0aab1&scoped=true&"
import script from "./UnusedResources.vue?vue&type=script&lang=ts&"
export * from "./UnusedResources.vue?vue&type=script&lang=ts&"
import style0 from "./UnusedResources.vue?vue&type=style&index=0&id=44b0aab1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b0aab1",
  null
  
)

export default component.exports